export default {
    data () {
        return{
            curTabId: this.$route.query.tabid ? parseInt(this.$route.query.tabid) : 0,
            orderStatus: [{
                    id: 1,
                    name: "等待确认",
                    selected: false
                },
                {
                    id: 2,
                    name: "试工订单",
                    selected: false
                },
                {
                    id: 3,
                    name: "成交订单",
                    selected: false
                },
            ],
            jobList:[],
        }
    },
    mounted () {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'distributedOrderList') {
                this.init();
            }
        }
    },
    methods:{
        init() {
            this.curTabId = this.$route.query.tabid ? parseInt(this.$route.query.tabid) : 0;
            // this.isLoaded = false;
            // this.page = 1;
            // this.getOrder();
            this.switchStatusTab(this.curTabId);
        },
        getOrder() {
            var _this=this;
            this.$post("/customerservicemanager/getlistjob",{
                OrderType: this.curTabId
            },function (res) {
                if(res.Result){
                    _this.jobList=res.Result.Data;
                    // console.log(_this.jobList);
                }else{
                    _this.$toast(res.Message);
                }
            })
        },
        //切换订单列表
        switchStatusTab(itemId) {
            let self = this;
            this.orderStatus.map(item => {
                if (item.id == parseInt(itemId)) {
                    // self.curTabId = parseInt(itemId);
                    // item.selected = true;
                    // item.selected = !item.selected;
                    self.curTabId = item.selected ? parseInt(item.id) : 0;
                } else {
                    item.selected = false;
                }
            });
            // self.page = 1;
            this.getOrder();
        },
        viewJob(job) {
            this.$router.push({
                name:"jobDetail", 
                query:{
                    id: job.JobId,
                    tabid: this.curTabId
                }
            })
        },
        //自定义返回
        customBack(){
            this.$router.push({
                path: "/center"
            });
        },
    },
}



// WEBPACK FOOTER //
// ./src/ally/page/user/distributedOrderList.js